module.exports = __webpack_public_path__ + "static/media/raindrop-app-min.63720b42.png";